/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSimulationPricingsSelfWorkerPricesMutation from '../graphql/mutations/SaveSimulationPricingsSelfWorkerPricesMutation.js';

export const useSaveSimulationPricingsSelfWorkerPricesMutation = () => {
  return useCommitMutation(SaveSimulationPricingsSelfWorkerPricesMutation, {
    dataProp: 'saveSimulationPricingsSelfWorkerPrices_M_simulation_pricings_self_worker'
  });
};

export default useSaveSimulationPricingsSelfWorkerPricesMutation;
